import { LoadingOutlined } from '@ant-design/icons';
import { ReactComponent as ForgotPasswordSuccess } from '@src/assets/images/ForgotPasswordSuccess.svg';
import { ReactComponent as ForgotPasswordSuccessDark } from '@src/assets/images/ForgotPasswordSuccessDark.svg';
import { AuthWrapper } from '@src/components';
import { ROUTE_FORGET_PASSWORD } from '@src/constants/URLS.const';
import { useCheckAuthResponse } from '@src/hooks';
import { useForgotPasswordMutation } from '@src/services/user/userApiSlice';
import { selectLayout, THEME } from '@src/store/layout/layoutSlice';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';

export function ForgotPasswordSuccessful() {
  const { t } = useTranslation();
  const layout = useSelector(selectLayout);
  const { checkAuthResponse } = useCheckAuthResponse();
  const { state } = useLocation();

  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();
  const resendEmail = async () => {
    const response = await forgotPassword({
      email: state.email,
    });

    checkAuthResponse(response, 'forgotPassword');
  };

  return (
    <AuthWrapper
      pageTitle={t('pages.auth.forgotPassword.success.title')}
      className='!pt-4 px-10 pb-8'
    >
      <div className='m-auto bg-wl-surface flex flex-col items-center'>
        {layout.theme === THEME.LIGHT ? (
          <ForgotPasswordSuccess className='w-full max-h-[200]' />
        ) : (
          <ForgotPasswordSuccessDark className='w-full max-h-[200]' />
        )}
        <div className='w-full mt-2 md:w-[327px]'>
          <h2 className='text-R-16 mb-6 text-theme-onSurface'>
            <div>
              <span className='mr-1'>
                {t('pages.auth.forgotPassword.success.message')}{' '}
              </span>
              <span className='font-bold'>{state.email}</span>
            </div>

            <div className='mt-6'>
              {t('pages.auth.forgotPassword.success.description')}
            </div>
          </h2>
          <div className='text-R-16text-theme-onSurface'>
            <div>
              {t('pages.auth.forgotPassword.success.notReceive')}
              <span
                className='ml-1 p-0 text-wl-primary text-M-16 cursor-pointer'
                onClick={resendEmail}
              >
                {isLoading ? (
                  <Spin indicator={<LoadingOutlined spin />} size='small' />
                ) : (
                  t('pages.auth.forgotPassword.success.resendLink')
                )}
              </span>
            </div>
            <div className='my-4'>
              {t('pages.auth.forgotPassword.success.wrongEmail')}
              <NavLink to={`/${ROUTE_FORGET_PASSWORD}`} className='pl-1'>
                <span className='text-wl-primary text-M-16'>
                  {t('pages.auth.forgotPassword.success.changeEmail')}
                </span>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </AuthWrapper>
  );
}
